import { post } from "../axios";
import ApiResponse from "sr/models/ApiResponse";
import { HandleApiError } from "sr/helpers/functions/HandleApiError";

export const uploadFile = async (postData: any) => {
  try {
    console.log("uploadFile: process.env.NODE_ENV", process.env.NODE_ENV);
    return await post<ApiResponse<[]>>(
      `${
        ["development"].indexOf(process.env.NODE_ENV) >= 0
          ? "https://jmm-api.bennettinfosys.com/api/v1"
          : ""
      }/util/directupload?file`,
      postData,
      { headers: { "Content-Type": "application/pdf" } },
    ).then((res) => {
      if (res.success === true) {
        return res;
      } else {
        return null;
      }
    });
  } catch (e: any) {
    HandleApiError(e);
  }
};
